<template>
  <div id="questionnaire__builder">
    <editor-area :selected-page="selectedPage"/>

    <aside id="controls__questionnaire__builder">
      <div id="controls__questionnaire__builder__content">
        <v-card>
          <ControlsHolder/>
        </v-card>
        <nav>
          <v-btn color="valid"
                 class="white--text"
                 @click.stop="onAdd">
            <v-icon right dark>mdi-file-plus</v-icon>
            {{ $t('components.questionnaires.buttons.addPage')}}
          </v-btn>

          <v-btn color="valid"
                 class="white--text"
                 @click.stop="openModalConfirmDeletion = true"
                 :disabled="!hasItems">
            <v-icon right dark>mdi-delete-sweep</v-icon>
            {{ $t('components.questionnaires.buttons.resetPage')}}
          </v-btn>

          <div id="custom__tooltip">
            <v-btn color="valid"
                   class="white--text"
                   @click.stop="onDelete"
                   :disabled="cannotRemove"
            >
              <v-icon right dark>mdi-delete-forever</v-icon>
              {{ $t('components.questionnaires.buttons.delete.name')}}
            </v-btn>

            <v-icon v-if="cannotRemove"
                    :title="$t('components.questionnaires.buttons.delete.info')"
                    class="app__tooltip__cursor__ernest">mdi-information
            </v-icon>
          </div>

          <v-btn color="valid"
                 class="white--text"
                 @click.stop="onSave"
                 :disabled="saveDisabled"
          >
            <v-icon right dark>mdi-cloud-upload</v-icon>
            {{ $t('components.buttons.save')}}
          </v-btn>
          <v-btn color="cancel"
                 class="white--text"
                 @click.stop="$router.push({ name : 'questionnaireList' })"
          >{{ $t('components.buttons.cancel')}}
          </v-btn>
        </nav>
      </div>
    </aside>

    <v-dialog
      v-model="openModalConfirmDeletion"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('components.questionnaires.modal.title')}}
        </v-card-title>

        <v-card-text>
          {{ $t('components.questionnaires.modal.text')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="cancel"
            class="white--text"
            @click="openModalConfirmDeletion = false"
          >
            {{ $t('components.buttons.cancel')}}
          </v-btn>

          <v-btn
            color="valid"
            class="white--text"
            @click="onClear"
          >
            {{ $t('components.questionnaires.modal.agree')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ControlsHolder from '@/components/questionnaires/ControlsHolder'
import EditorArea from '@/components/questionnaires/EditorArea'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuestionnaireBuilder',
  props: {
    selectedPage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      openModalConfirmDeletion: false
    }
  },
  components: {
    ControlsHolder,
    EditorArea
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'workingPages'
    ]),
    hasItems () {
      return this.workingPages[this.selectedPage].pageItems.length !== 0
    },
    cannotRemove () {
      return this.workingPages.length === 1 || this.hasItems
    },
    saveDisabled () {
      return this.workingPages.some(
        page => page.pageItems.length === 0 || page.pageItems.some(pageItem =>
          pageItem.type === 'question' ? pageItem.value === ''
            : ['', '<br>', '<div><br></div>'].includes(pageItem.value)
        )
      )
    }
  },
  methods: {
    ...mapActions('Questionnaires', [
      'workingPageInsert',
      'workingPageRemove',
      'workingPageReset'
    ]),
    onAdd () {
      this.workingPageInsert(this.selectedPage + 1)
      this.$emit('next')
    },
    onClear () {
      this.openModalConfirmDeletion = false
      this.workingPageReset(this.selectedPage)
    },
    onDelete () {
      this.workingPageRemove(this.selectedPage)
    },
    onSave () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppTooltipErnest";

  #questionnaire__builder {
    display: grid;
    grid-template-columns: 10fr 2.5fr;
    grid-column-gap: 10px;

    aside#controls__questionnaire__builder {
      position: relative;

      div#controls__questionnaire__builder__content {
        position: sticky;
        top: 10px;

        nav {
          margin-top: 10px;
          display: flex;
          flex-direction: column;

          button {
            display: flex;
            justify-content: flex-start;
          }
        }

        button {
          &:nth-child(2) {
            margin: 10px 0 5px 0;
          }

          &:nth-child(4) {
            margin: 5px 0 5px 0;
          }

          &:nth-child(5) {
            margin: 5px 0 10px 0;
          }

          i {
            margin: 0 16px 0 0;
          }
        }

        #custom__tooltip {
          display: flex;

          i {
            margin-left: 5px;
          }

          button {
            margin: 5px 0 5px 0;
          }
        }
      }
    }
  }
</style>
